import {FlexFillColumn} from "../../../../themes/utils";
import Item from './Item/index'
import useRolHook from "../../../../hooks/useRolHook";
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import QrCodeRoundedIcon from '@mui/icons-material/QrCodeRounded';
export const ItemList = () => {

    const rol = useRolHook();

    return (
        <FlexFillColumn>

            <Item icon={<StorefrontRoundedIcon/>} text={"QR estático/dinámico"} index={0} redirect={'/qr'}></Item>

            <Item icon={<QrCodeRoundedIcon/>} text={"Ecommerce"} redirect={'/ecommerce'} index={1}></Item>


        </FlexFillColumn>
    );
};